import { load } from './component-loader'

const Index = load('storeInformation/Index')
const StoreHours = load('storeInformation/StoreHours')
const StoreAddress = load('storeInformation/StoreAddress')
const VirtualTour = load('storeInformation/VirtualTour')

const initialTitle = " | Eichlers  ";
export default[
    {
        path:"/store-information",
        name:"StoreInformationIndex",
        component:Index,
        meta:{title:"Store Information" + initialTitle},
        redirect:{name:"StoreAddress"},
        children:[
            {
                path:"hours",
                name:"StoreHours",
                component:StoreHours,
                meta:{title:"Store Hours" + initialTitle},
            },
            {
                path:"address",
                name:"StoreAddress",
                component:StoreAddress,
                meta:{title:"Store Address" + initialTitle},
            },
            {
                path:"virtual-tour",
                name:"VirtualTour",
                component:VirtualTour,
                meta:{title:"Virtual Tour" + initialTitle},
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./resources/js/router/storeInfomation.js